import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { ROLE_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, editRole } from 'src/reducers/clients/roles';
import { setItem, getItem, getItemErrors } from 'src/reducers/common/itemReducer';

import RoleForm from './containers/RoleForm';

let EditRoleForm = reduxForm({
  form: ROLE_FORM
})(RoleForm);

const mapStateToProps = state => ({
  isNewForm: false,
  initialValues: getItem(REDUCER_NAME, state),
  errors: getItemErrors(REDUCER_NAME, state)
});
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(editRole(data));
  }
});
EditRoleForm = connect(mapStateToProps, mapDispatchToProps)(EditRoleForm);

const EditRole = ({ dispatch, role }) => {
  dispatch(setItem(REDUCER_NAME, role));
  return (
    <div>
      <EditRoleForm />
    </div>
  );
};

export default connect()(EditRole);
